<template>
    <div class="container live-form">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <mt-field class="menu-item" label="直播标题" v-model="live_apply_info.live_apply_name" />
        <mt-cell class="pt-5" title="直播封面">
            <div class="user-avatar-wrapper">
                <div v-if="live_apply_info.live_apply_cover_image" class="user-avatar">
                    <img :src="live_apply_info.live_apply_cover_image_url">
                    <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
                </div>
                <div v-else-if="live_apply_info.live_apply_cover_video" class="user-avatar">
                    <video :src="live_apply_info.live_apply_cover_video_url" />
                    <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
                </div>
                <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage">
                    <div class="center-text">2M以下图片或视频（mp4格式）</div>
                    <input type="file">
                </div>
            </div>
        </mt-cell>
        <div @click="onDatetime"><mt-cell title="直播时间" is-link>{{live_apply_play_time?$moment.unix(live_apply_play_time).format('YYYY-MM-DD HH:mm'):''}}</mt-cell></div>
        <div @click="popupSelect = true">
            <mt-cell title="选择商品" is-link>{{selectGoodsId.length?('已选' + selectGoodsId.length + '件'):''}}</mt-cell>
        </div>
        <mt-popup v-model="popupSelect" position="right" class="common-popup-wrapper" :modal="false">
            <div class="common-header-wrap">
                <mt-header title="选择商品" class="common-header">
                    <mt-button slot="left" icon="back" @click.native="popupSelect = false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div class="select-goods" v-if="selectGoodsList">
                        <ul v-if="selectGoodsList.length">
                            <li v-for="item in selectGoodsList" v-bind:key="item.goods_commonid" :class="{'active':selectGoodsId.indexOf(item.goods_commonid)>-1}" @click="selectedGoods(item)">
                                <div class="p-img">
                                    <img :src="item.goods_image"/>
                                </div>
                                <div class="p-info">
                                    <p class="name">{{item.goods_name}}</p>
                                    <p class="price">{{item.goods_price}}</p>
                                </div>
                            </li>
                        </ul>
                        <empty-record v-else></empty-record>
                    </div>
                </div>
            </div>
        </mt-popup>
        <mt-field class="menu-item" label="申请备注" type="textarea" rows="4" v-model="live_apply_info.live_apply_remark" />
        <mt-button class="ds-button-large" type="primary"  v-on:click="submit">保存</mt-button>
        <div v-show="showTime">
            <mt-datetime-picker
                    :closeOnClickModal="false"
                    ref="datetimePicker"
                    type="datetime"
                    :startDate="new Date()"
                    yearFormat="{value}年"
                    monthFormat="{value}月"
                    dateFormat="{value}日"
                    hourFormat="{value}时"
                    minuteFormat="{value}分"
                    :value="live_apply_play_time?(new Date(live_apply_play_time)):(new Date())"
                    @confirm="datetimeConfirm"
                    @cancel="showTime=false"
            >
            </mt-datetime-picker>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getLiveApplyInfo, saveLiveApply, uploadInfoFile } from '../../../api/sellerLiveApply'
import { getGoodsList } from '../../../api/sellerGoods'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  props: {
    ifComponent: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: function () {
        return { action: 'add', live_apply_id: 0 }
      }
    }
  },
  computed: {
    isAddMode () {
      let mode = this.ifComponent ? this.query.action : this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增直播'
      } else {
        return '修改直播'
      }
    }

  },
  data () {
    return {
      live_apply_play_time: 0,
      live_apply_info: {},
      showTime: false,
      popupSelect: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      selectGoodsList: false,
      selectGoodsId: [],
      keyword: '',
      goods_type: '',
      search_type: '',
      showimage: '',
      isshow: false
    }
  },
  created: function () {
    this.initLive()
  },
  watch: {
    query: function (val) {
      this.live_apply_id = val.live_apply_id
      this.initLive()
    }
  },
  methods: {
    goBack () {
      if (this.ifComponent) {
        this.$emit('closeLiveApplyForm')
      } else {
        this.$router.go(-1)
      }
    },
    initLive () {
      if (!this.isAddMode) {
        getLiveApplyInfo(this.live_apply_id).then(res => {
          var live_apply_info = res.result.live_apply_info
          this.live_apply_play_time = live_apply_info.live_apply_play_time
          this.live_apply_info = live_apply_info
        }).catch(function (error) {
          Toast(error.message)
        })
      }
    },
    datetimeConfirm (value) {
      this.live_apply_info.live_apply_play_time = parseInt(value.getTime() / 1000)
      this.live_apply_play_time = this.live_apply_info.live_apply_play_time
      this.showTime = false
    },
    onDatetime (picker, values) {
      this.showTime = true
      this.$refs.datetimePicker.open()
    },
    submit () {
      saveLiveApply(Object.assign({}, this.live_apply_info, { goods_ids: this.selectGoodsId })).then(res => {
        if (this.ifComponent) {
          this.$emit('saveLiveApply')
        } else {
          this.$router.push({ name: 'SellerLiveApplyList' })
        }
      }).catch(error => {
        Toast(error.message)
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getSelectGoodsList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.selectGoodsList = []
      this.loadMore()
    },
    // 获取商品列表 用于设置产品分佣
    getSelectGoodsList () {
      getGoodsList('Sellergoodsonline', this.params, this.keyword, this.goods_type, this.search_type).then(res => {
        if (this.selectGoodsList) {
          this.selectGoodsList = this.selectGoodsList.concat(res.result.goods_list)
        } else {
          this.selectGoodsList = res.result.goods_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 选择商品
    selectedGoods (item) {
      var index = this.selectGoodsId.indexOf(item.goods_commonid)
      if (index > -1) {
        this.selectGoodsId.splice(index, 1)
      } else {
          if(this.selectGoodsId.length>=10){
              Toast('最多选10件商品')
              return
          }
        this.selectGoodsId.push(item.goods_commonid)
      }
    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage () {
      this.live_apply_info.live_apply_cover_image = ''
      this.live_apply_info.live_apply_cover_video = ''
      this.$forceUpdate()
    },
    uploadImage (event) {
      if (typeof (event.target.files[0]) === 'undefined') {
        return
      }
      let formdata = new FormData()

      formdata.append('file', event.target.files[0])
      formdata.append('name', 'file')

      uploadInfoFile(formdata).then(res => {
        if (res.result.file_type == 'image') {
          this.live_apply_info.live_apply_cover_video = ''
          this.live_apply_info.live_apply_cover_video_url = ''
          this.live_apply_info.live_apply_cover_image = res.result.file_name
          this.live_apply_info.live_apply_cover_image_url = res.result.file_path
        } else {
          this.live_apply_info.live_apply_cover_image = ''
          this.live_apply_info.live_apply_cover_image_url = ''
          this.live_apply_info.live_apply_cover_video = res.result.file_name
          this.live_apply_info.live_apply_cover_video_url = res.result.file_path
        }

        this.$forceUpdate()
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .select-goods li{height:3rem;padding:.6rem;display:flex;}
    .select-goods li.active{background: rgba(255, 203, 203, 0.5) }
    .select-goods li .p-img{}
    .select-goods li .p-img img{width:3rem;height: 3rem;}
    .select-goods li .p-info{margin-left:1rem;}
    .select-goods li .p-info p{line-height:1rem;}
    .select-goods li .p-info .price{font-size:0.6rem;color:$primaryColor;height:2rem;overflow: hidden}
    .select-goods li .p-info .name{font-size:0.7rem;}
    .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
    .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
    .user-avatar {
        display: block;
        border:1px solid #eee;
        position: relative;
        width: 5rem;
        height: 5rem;
        margin: 0 auto;
        text-align: center;
        img,video {
            width: 100%;
            height: 100%
        }
        input {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0
        }
        .center-text{padding:.2rem;padding-top:3.5rem;font-size:.6rem}
        /*.desc-text{font-size: .5rem;color: #999}*/
    }
    .user-avatar::before {
        position: absolute;
        font-size: 1.5rem;
        line-height: 5rem;
        left: 50%;
        margin-left: -.75rem;
        color: rgba(0, 0, 0, 0.5)
    }
</style>
